export const WCRA = 'wcra';

export const RET = 'ret';

export const VRQ = 'vrq';
